export const UPDATE_LOOKER_FRAME = "UPDATE_LOOKER_FRAME";
export const UPDATE_LOOKER_TABS_VISITED = "UPDATE_LOOKER_TABS_VISITED";
export const SET_LOOKER_FRAME = "SET_LOOKER_FRAME";
export const SET_LOOKER_TYPE = "SET_LOOKER_TYPE";

const updateLookerFrameAction = (payload) => ({
    type: UPDATE_LOOKER_FRAME,
    updatedUrl: payload
});

const updateLookerTabsVisited = (payload) => ({
    type: UPDATE_LOOKER_TABS_VISITED,
    updatedTab: payload
});

const setAnalyticsLookerAction = (payload) => ({
    type: SET_LOOKER_FRAME,
    setUrl: payload
});

const setRiskTypeAction = (payload) => ({
    type: SET_LOOKER_TYPE,
    setType: payload
});

export { updateLookerFrameAction, updateLookerTabsVisited, setAnalyticsLookerAction, setRiskTypeAction };